import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { Radio, TableHead } from "@mui/material";
import { HeadColType } from "src/types/paginationTypes";
import { DropScheduleRecord } from "../allBids/PreBackorderModel";
import { Dispatch, SetStateAction } from "react";
import { preBackorderSelectedRowStyle } from "../allBids/modelStyles";
import EmptyTable from "./EmptyTable";
import { formatDate } from "src/utils/helperFunctions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

const headRow: HeadColType[] = [
    {
        label: "Date",
        align: "center",
    },
    {
        label: "Amount ($)",
        align: "right",
    },
    {
        label: "",
        align: "center",
        width: "2px",
    },
];

const PreBackorderScheduleTable = ({
    schedule,
    selectedIndex,
    setSelectedIndex,
}: {
    schedule: DropScheduleRecord[];
    selectedIndex: number;
    setSelectedIndex: Dispatch<SetStateAction<number>>;
}) => {
    return (
        <TableContainer>
            <Table aria-label="custom simple table">
                <TableHead sx={{ bgcolor: "#0000000F" }}>
                    <TableRow>
                        {headRow.map((col) => (
                            <TableCell
                                key={col.label}
                                align={col.align ?? "right"}
                                style={
                                    col.width
                                        ? {
                                              width: col.width,
                                              minWidth: col.width,
                                              maxWidth: col.width,
                                              padding: "1px",
                                          }
                                        : {}
                                }
                            >
                                {col.component ? col.component : col.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {schedule.length > 0 ? (
                        schedule.map((row: any, index: number) => {
                            const isDisabled = row.isValid === false;

                            return (
                                <TableRow
                                    key={`schedule_row_${index}_${row.dropTimeMS}`}
                                    onClick={
                                        !isDisabled
                                            ? () => setSelectedIndex(index)
                                            : undefined
                                    }
                                    sx={{
                                        ...(selectedIndex === index
                                            ? preBackorderSelectedRowStyle
                                            : {
                                                  cursor: isDisabled
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity: isDisabled ? 0.5 : 1,
                                              }),
                                    }}
                                >
                                    <TableCell
                                        align="center"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        <Radio
                                            checked={selectedIndex === index}
                                            value={index}
                                            color="primary"
                                            tabIndex={-1}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() =>
                                                setSelectedIndex(index)
                                            }
                                            size="small"
                                            disabled={isDisabled}
                                            sx={{
                                                padding: 0,
                                                marginRight: 3,
                                                color:
                                                    selectedIndex === index
                                                        ? "#FFB700"
                                                        : undefined,
                                                "&.Mui-checked": {
                                                    color: "#FFB700",
                                                },
                                            }}
                                        />
                                        {formatDate(row.dropTimeMS)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.fee.toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{
                                            padding: "1px",
                                            paddingTop: "2px",
                                            paddingBottom: "2px",
                                        }}
                                    >
                                        {isDisabled && row.invalidReason && (
                                            <Tooltip
                                                title={row.invalidReason}
                                                arrow
                                            >
                                                <InfoOutlinedIcon
                                                    sx={{ fontSize: "13px" }}
                                                    color="action"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    ) : (
                        <EmptyTable colSpan={2} msg="No Data" />
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PreBackorderScheduleTable;
